import { INetworkPrintingConfig, IGetPrinterDPIConfig, IGetPrinterDPIResult } from '../NetworkPrintingTypes';

/**
 * Abstract base class for all network printing adapters.
 * Defines the contract that all concrete network printing adapters must implement.
 */
export abstract class AbstractNetworkPrintingAdapter {
    /**
     * Prints the provided ZPL data to the specified network printer.
     *
     * @param config - Configuration object containing printer IP, ZPL data, and optional port
     * @returns Promise that resolves when the print operation completes successfully,
     *          or rejects with an appropriate NetworkPrintingException on failure
     */
    public abstract print(config: INetworkPrintingConfig): Promise<any>;

    /**
     * Queries the DPI of a network printer.
     *
     * @param config - Configuration object containing printer IP and optional port
     * @returns Promise that resolves with the printer DPI result
     */
    public abstract getPrinterDPI(config: IGetPrinterDPIConfig): Promise<IGetPrinterDPIResult>;
}
